import { Lightbulb } from 'lucide-react';

import { Badge } from '@/components/ui';
import type { ErrorGuidance } from '@/types/api';

/**
 * Analyst playbook callout shown above the resolution panel.
 * Backend lookup is in `backend/ett/api/routes/error_playbook.py`.
 */
export function GuidancePanel({ guidance }: { guidance: ErrorGuidance }) {
  return (
    <div className="mb-3 rounded border border-amber-200 bg-amber-50/60 p-3">
      <div className="mb-1 flex items-center gap-2">
        <Lightbulb className="h-4 w-4 text-amber-600" aria-hidden />
        <h4 className="text-h4 text-amber-900">{guidance.title}</h4>
      </div>
      <p className="mb-2 text-small text-amber-900/90">{guidance.description}</p>
      <details className="text-small">
        <summary className="cursor-pointer text-amber-900 hover:underline">
          What each action does
        </summary>
        <dl className="mt-2 space-y-2">
          {guidance.actions.map((a) => (
            <div key={a.action_id}>
              <dt className="flex items-center gap-2 font-medium text-slate-900">
                {a.label}
                {a.action_id === guidance.recommended_action && (
                  <Badge variant="accent" className="text-small">
                    recommended
                  </Badge>
                )}
              </dt>
              <dd className="text-slate-700">{a.description}</dd>
            </div>
          ))}
        </dl>
      </details>
    </div>
  );
}
